export default class WorkerFactory {
  constructor(workerFunction) {
    const blob = new Blob([`(${workerFunction.toString()})()`]);
    return new Worker(URL.createObjectURL(blob));
  }
}
